import { createServiceClient } from 'utils/apiClient'

const collaboratorClient = createServiceClient('/collaborator')

export default collaboratorClient
